<template>
  <v-dialog :model-value="modelValue" max-width="960" scrollable @update:model-value="$emit('update:modelValue', $event)">
    <v-card rounded="lg" class="share-dialog-card">
      <div class="d-flex justify-end pa-2 pb-0">
        <v-btn icon="mdi-close" size="small" variant="text" color="grey"
          @click="$emit('update:modelValue', false)" />
      </div>
      <v-card-text class="pa-4 pt-0">
        <form-share-options v-if="modelValue" :key="formId" :form-id="formId" :initial-tab="initialTab" dense />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import FormShareOptions from './FormShareOptions'

export default {
  name: 'FormShareDialog',
  components: { FormShareOptions },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    formId: {
      type: Number,
      default: null
    },
    initialTab: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.share-dialog-card {
  overflow-x: hidden;
}
</style>
